import { Link, NavLink } from "react-router-dom";
import { useState } from "react";
import { Menu, X, LayoutDashboard } from "lucide-react";
import { LOGO_URL, COMPANY_NAME, NAV_LINKS } from "../lib/site";
import { Button } from "@/components/ui/button";
import { useUserAuth } from "../lib/UserAuthContext";

export default function Header() {
  const [open, setOpen] = useState(false);
  const { user } = useUserAuth();

  const AuthCtas = ({ mobile = false, onNav }) => (
    user ? (
      <Link to="/dashboard" onClick={onNav} data-testid={mobile ? "mobile-dashboard-link" : "header-dashboard-link"}>
        <Button className={`${mobile ? "w-full" : ""} rounded-full bg-[#FF6B00] hover:bg-[#E65C00] text-white font-semibold px-6 h-11`}>
          <LayoutDashboard size={16} className="mr-1.5" /> Dashboard
        </Button>
      </Link>
    ) : (
      <div className={`${mobile ? "flex flex-col gap-2" : "flex items-center gap-2"}`}>
        <Link to="/login" onClick={onNav} data-testid={mobile ? "mobile-login-button" : "header-login-button"}>
          <Button variant="outline" className={`${mobile ? "w-full" : ""} rounded-full border-2 border-slate-200 hover:border-[#0B192C] text-[#0B192C] font-semibold px-5 h-11`}>
            Login
          </Button>
        </Link>
        <Link to="/register" onClick={onNav} data-testid={mobile ? "mobile-signup-button" : "header-signup-button"}>
          <Button className={`${mobile ? "w-full" : ""} rounded-full bg-[#FF6B00] hover:bg-[#E65C00] text-white font-semibold px-6 h-11`}>
            Sign Up
          </Button>
        </Link>
      </div>
    )
  );

  return (
    <header data-testid="site-header" className="sticky top-0 z-50 bg-white/85 backdrop-blur-xl border-b border-slate-200/70">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 sm:h-20 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3" data-testid="brand-logo-link">
          <img src={LOGO_URL} alt={COMPANY_NAME} className="h-9 w-9 sm:h-10 sm:w-10 object-contain" />
          <span className="font-display font-bold text-lg sm:text-xl text-[#0B192C] tracking-tight">
            CashPark <span className="text-[#FF6B00]">Inc</span>
          </span>
        </Link>

        <nav className="hidden md:flex items-center gap-8" data-testid="desktop-nav">
          {NAV_LINKS.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              data-testid={`nav-link-${n.label.toLowerCase()}`}
              className={({ isActive }) =>
                `text-sm font-semibold transition-colors ${isActive ? "text-[#FF6B00]" : "text-slate-700 hover:text-[#0B192C]"}`
              }
              end={n.to === "/"}
            >
              {n.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden md:block">
          <AuthCtas />
        </div>

        <button
          className="md:hidden text-[#0B192C]"
          onClick={() => setOpen(!open)}
          data-testid="mobile-menu-toggle"
          aria-label="Toggle menu"
        >
          {open ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-slate-200 bg-white" data-testid="mobile-nav">
          <div className="px-4 py-4 flex flex-col gap-2">
            {NAV_LINKS.map((n) => (
              <NavLink
                key={n.to}
                to={n.to}
                onClick={() => setOpen(false)}
                data-testid={`mobile-nav-link-${n.label.toLowerCase()}`}
                className={({ isActive }) =>
                  `py-2 text-base font-semibold ${isActive ? "text-[#FF6B00]" : "text-slate-700"}`
                }
                end={n.to === "/"}
              >
                {n.label}
              </NavLink>
            ))}
            <div className="mt-2">
              <AuthCtas mobile onNav={() => setOpen(false)} />
            </div>
          </div>
        </div>
      )}
    </header>
  );
}
